<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import { sessionHelper, ddlHelper } from "@/utils";
import { SESSION, SHARED } from "@/constants";
import { mapState } from "vuex";
import { PASSWORD_RESET_MODULE } from '@/state/modules/passwordReset'
import { passwordResetMethods } from "@/state/helpers";

export default {
  page: {
    title: i18n.t("label.listingX", [i18n.t('module.passwordReset')]),
  },
  beforeRouteLeave(to, from, next) {
    sessionHelper.clearSearch(SESSION.CUSTOMER_PASSWORD_RESET_SEARCH)
    next();
  },
  created() {
    this.initSearchCriteria();
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: i18n.t("label.listingX", [i18n.t('module.passwordReset')]),
      statusDdl: ddlHelper.getActivationStatus(true),
      currentPage: 1,
      filter: "",
      enabled: false,
      perPage: SHARED.DEFAULT_PAGE_SIZE,
      pageOptions: [10, 25, 50, 100],
      filterOn: [],
      sortBy: "name",
      fields: [
        { key: "name", sortable: true, label: i18n.t('label.name') },
        { key: "email", sortable: true, label: i18n.t('label.email') },
        // { key: "token", sortable: true, label: i18n.t('label.token') },
        { key: "purpose", sortable: true, label: i18n.t('label.purpose') },
        { key: "createdAt", sortable: true, label: i18n.t('label.createdAt') },
        { key: "isUsed", sortable: true, label: i18n.t('label.status') },
        { key: "Action", sortable: false, label: i18n.t('label.action') },
      ],
    };
  },
  computed: {
    ...mapState(PASSWORD_RESET_MODULE, ["status"]),
    tableRows() {
      return this.$store.state.passwordReset.list.data;
    },
    pagination() {
      return this.$store.state.passwordReset.list.pagination;
    },
    totalPage() {
      return this.$store.state.passwordReset.list.pagination.total;
    },
  },
  mounted() { },
  methods: {
    ...passwordResetMethods,
    initSearchCriteria() {
      let isDefault = true;

      if (sessionHelper.hasSearchCriteria(SESSION.CUSTOMER_PASSWORD_RESET_SEARCH)) {
        isDefault = false;
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.CUSTOMER_PASSWORD_RESET_SEARCH);
      }

      if (isDefault) {
        this.searchCriteria = {
          pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
          pageSize: SHARED.DEFAULT_PAGE_SIZE,
          isActive: this.statusDdl[0].value,
          searchValue: "",
          searchArray: [],
        };
      }
      this.getPasswordResetList(this.searchCriteria);
    },

    getPasswordResetList(filter) {
      this.getAllPasswordReset({ filter });
      // this.$store.dispatch(`passwordReset/getAllPasswordReset`, { filter });
      this.searchCriteria = filter;
      sessionHelper.storeSearch(SESSION.CUSTOMER_PASSWORD_RESET_SEARCH, filter);
    },

    pageNavigation(pageNumber) {
      let filter = sessionHelper.retrieveSearch(SESSION.CUSTOMER_PASSWORD_RESET_SEARCH);
      filter.pageNumber = pageNumber;

      this.getPasswordResetList(filter);
    },

    searchListing() {
      this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
      this.searchCriteria.searchArray = [];
      this.searchCriteria.searchArray.push(this.filter);
      this.getPasswordResetList(this.searchCriteria);
    },

    resendEmail(passwordReset) {
      const data = {
        otp: passwordReset.token,
        purpose: passwordReset.purpose,
      };
      this.resend({ filter: this.searchCriteria, data });
    }

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right" style="float: left">
                  <label class="d-inline-flex align-items-center">
                    {{ $t('label.search') }}
                    <b-form-input v-model="filter" type="search" :placeholder="$t('label.search')"
                      class="form-control form-control-sm ml-2" @change="searchListing"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table :items="tableRows" :fields="fields" responsive="sm" :per-page="perPage">
                <template #cell(isUsed)="data">
                  <b-badge variant="info" v-if="tableRows[data.index].isUsed == 1 || tableRows[data.index].isUsed == '1'">Used</b-badge>
                  <b-badge variant="success" v-if="tableRows[data.index].isUsed == 0 || tableRows[data.index].isUsed == '0'">Not Used</b-badge>
                </template>
                <template #cell(action)="data">
                  <a href="javascript:void(0);" @click="resendEmail(tableRows[data.index])" v-b-tooltip.hover title="Edit" class="text-info">
                    <i class="mdi mdi-email-send font-size-18"></i>
                  </a>

                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="pagination.total" :per-page="perPage"
                      @change="pageNavigation"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
a.disabled {
  pointer-events: none;
  cursor: default;
}
</style>